import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type {
  CustomerRole,
  CustomerRoleCreateRequest,
  CustomerRoleUpdateRequest,
  CustomerRoleWithAssignedCount,
} from '../types/role';

export interface CustomerRolesApiContract {
  list(): Promise<CustomerRoleWithAssignedCount[]>;
  get(slug: string): Promise<CustomerRoleWithAssignedCount>;
  create(payload: CustomerRoleCreateRequest): Promise<CustomerRole>;
  update(slug: string, payload: CustomerRoleUpdateRequest): Promise<CustomerRole>;
  delete(slug: string): Promise<void>;
}

/**
 * API for customer roles (list, get, create, update, delete).
 * Paths match OpenAPI: /api/v2/customer-roles (inline with rest of customers API).
 */
export class CustomerRolesApi extends ApiService implements CustomerRolesApiContract {
  public list(): Promise<CustomerRoleWithAssignedCount[]> {
    return this.api.proxy({
      method: 'GET',
      path: '/v2/customer-roles',
    });
  }

  public get(slug: string): Promise<CustomerRoleWithAssignedCount> {
    return this.api.proxy({
      method: 'GET',
      path: '/v2/customer-roles/{slug}',
      params: { slug },
    });
  }

  public create(payload: CustomerRoleCreateRequest): Promise<CustomerRole> {
    return this.api.proxy({
      method: 'POST',
      path: '/v2/customer-roles',
      payload,
    });
  }

  public update(slug: string, payload: CustomerRoleUpdateRequest): Promise<CustomerRole> {
    return this.api.proxy({
      method: 'PUT',
      path: '/v2/customer-roles/{slug}',
      params: { slug },
      payload,
    });
  }

  public delete(slug: string): Promise<void> {
    return this.api.proxy({
      method: 'DELETE',
      path: '/v2/customer-roles/{slug}',
      params: { slug },
    });
  }
}
